"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialEconomyState = exports.economyReducer = exports.setErrors = exports.setIsEdited = exports.setSelectedEarnConfig = exports.clearState = exports.setSelectedCurrency = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    selectedCurrency: {
        name: "",
        code: "",
        type: "",
        conversion_rate: 0,
        icon: {
            name: "",
            prefix: "",
            url: "",
            etag: "",
        },
    },
    selectedEarnConfig: {
        trigger_value: 0,
        type: null,
        earn_target: "",
        earn_amount: 0,
        excluded_product_ids: [],
        excluded_category_ids: [],
        segment_id: "",
        exclude_type: "product",
    },
    isEdited: false,
    errors: {},
};
exports.initialEconomyState = initialState;
var slice = (0, toolkit_1.createSlice)({
    name: "economicsState",
    initialState: initialState,
    reducers: {
        setSelectedCurrency: function (state, action) {
            state.selectedCurrency = action.payload;
        },
        clearState: function (state) {
            Object.assign(state, initialState);
        },
        setSelectedEarnConfig: function (state, action) {
            state.selectedEarnConfig = action.payload;
        },
        setIsEdited: function (state, action) {
            state.isEdited = action.payload;
        },
        setErrors: function (state, action) {
            state.errors = action.payload;
        },
    },
});
var _a = slice.actions, setSelectedCurrency = _a.setSelectedCurrency, clearState = _a.clearState, setSelectedEarnConfig = _a.setSelectedEarnConfig, setIsEdited = _a.setIsEdited, setErrors = _a.setErrors;
exports.setSelectedCurrency = setSelectedCurrency;
exports.clearState = clearState;
exports.setSelectedEarnConfig = setSelectedEarnConfig;
exports.setIsEdited = setIsEdited;
exports.setErrors = setErrors;
var economyReducer = slice.reducer;
exports.economyReducer = economyReducer;
